import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { useEffect } from 'react';
import { IAdminxStore } from '../../stores';

interface IBidderChangesLogsProps {
	startDate?: string;
	endDate?: string;
	campaignId?: number;
}

export function useBidderChangesLogs(props: IBidderChangesLogsProps) {
	const { startDate, endDate, campaignId } = props;
	const { bidderStore } = useStores<IAdminxStore>();

	const formatDateTime = (dateTime: string) => {
		if (!dateTime) {
			return dateTime;
		}
		return dateTime.replace('T', ' ') + ':00';
	};

	useEffect(() => {
		if (startDate && endDate) {
			const formattedStartDate = formatDateTime(startDate);
			const formattedEndDate = formatDateTime(endDate);

			const params = new URLSearchParams();
			params.set('ts_start', formattedStartDate);
			params.set('ts_end', formattedEndDate);
			if (campaignId && campaignId !== 0) {
				params.set('id', campaignId.toString());
			}

			bidderStore.changesLogsList.reset();
			bidderStore.changesLogsList.fetch(params);
		}
	}, [startDate, endDate, campaignId, bidderStore]);

	return {
		data: bidderStore.changesLogsList.getList(),
		isLoading: bidderStore.changesLogsList.getIsLoading(),
		error: bidderStore.changesLogsList.getError(),
	};
}
